import { render } from "./index.vue?vue&type=template&id=df5347be&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=df5347be&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-df5347be"

export default script